<template>
  <div class="fee-table">
    <el-form ref="feeForm" :model="formModel" :disabled="disabled">
      <el-table
          ref="multipleTable"
          :data="formModel.tableData"
          border
          row-key="id"
          :key="tableKey"
          class="deduction-list"
          max-height="400"
          @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column
            type="selection"
            reserve-selection
            :selectable="() => true"
        /> -->
        <el-table-column label="支付顺序" width="80">
            <template slot-scope="scope">
            {{ scope.$index + 1 }}
            </template>
        </el-table-column>
        <el-table-column prop="feeTypeName" label="支付费项" align="center" width="100">
            <template slot-scope="scope">
            <div>{{ scope.row.feeTypeName }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="feeAmount" label="金额" align="center">
            <template slot-scope="scope">
            <el-form-item
                label-width="auto"
                class="amount-input"
                :prop="`tableData.${scope.$index}.feeAmount`"
                :rules="[
                    { required: true, message: '请输入金额', trigger: 'change' },
                    { validator: (rule, value, callback) =>
                    validateAmount(rule, value, callback, scope.row), trigger: 'change' }
                ]">
                <span style="position: relative; top: 12px" v-if="scope.row.customFlag === CUSTOM_FLAG.NORMAL">{{ scope.row.feeAmount }}元</span>
                <el-input v-else
                    :style="{
                        width: '150px',
                        marginTop: scope.row.customFlag === CUSTOM_FLAG.NORMAL ? '4px' : '0px'
                    }"
                    v-number:money="{
                        isHideErr: true,
                    }"
                    v-model="scope.row.feeAmount"
                    placeholder="请输入"
                >
                    <template slot="append">元</template>
                </el-input>
            </el-form-item>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="160">
            <template slot-scope="{ $index, row }">
            <div class="action-buttons">
                <el-button
                    type="text"
                    :disabled="$index === 0"
                    @click="handleMoveUp(row.id)"
                >
                上移
                </el-button>
                <el-button
                    type="text"
                    :disabled="$index === formModel.tableData.length - 1"
                    @click="handleMoveDown(row.id)"
                >
                    下移
                </el-button>
                <el-button
                    v-if="row.isAdd"
                    type="text"
                    @click="handleDelete(row.id)"
                >
                删除
                </el-button>
            </div>
            </template>
        </el-table-column>
      </el-table>
    </el-form>
    <el-dropdown
      @command="handleAddFeeItem"
      :disabled="getAddItemDisabled || disabled"
      trigger="hover"
    >
      <el-button
        type="primary"
        :disabled="getAddItemDisabled || disabled"
      >
        添加费项<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) in getCustomFeeList"
          :key="`${item.feeType}-${index}`"
          :command="item"
        >
          {{ item.feeTypeName }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, set, toRefs, watch } from 'vue'
import { CUSTOM_FLAG } from '@/pages/orders_new/withholdDrawer/config'
import { getEnum } from '@/api/global'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  allFeeTypeList: {
    type: Array,
    default: () => [],
  },
})

const { disabled, allFeeTypeList } = toRefs(props)


const formModel = ref({
  tableData: [],
})
const tableKey = ref(0)
const isProgrammaticSelection = ref(false)
const customFeeList = ref([])


const multipleTable = ref(null)
const feeForm = ref(null)

// 强制重新渲染的方法
const forceRerender = () => {
  tableKey.value += 1
}


const validateAmount = (_, value, callback, row) => {
  if (value === '') {
    callback(new Error('请输入金额'))
  } else if (shouldValidateAmountLimit(row) && value > 10000) {
    callback(new Error('金额不能大于10000'))
  } else {
    callback()
  }
}

// 判断是否需要校验金额上限
const shouldValidateAmountLimit = (rowData) => {
  // 只有后置费项和已选择的项需要校验金额上限
  // customFlag: 0: 签约时选择的费项  1: 后置费项
  return rowData.customFlag === 1 && rowData?.selected === 1
}

const handleSelectionChange = (selections) => {
  formModel.value.tableData.forEach((item) => {
    const isSelected = selections.some((selected) => selected.id === item.id)
    item.selected = isSelected ? 1 : 0
  })
}


// 上移
const handleMoveUp = (id) => {
  const index = formModel.value.tableData.findIndex((item) => item.id === id)
  if (index > 0) {
    const current = formModel.value.tableData[index]
    const prev = formModel.value.tableData[index - 1]
    set(formModel.value.tableData, index - 1, current)
    set(formModel.value.tableData, index, prev)
  }
}
// 下移
const handleMoveDown = (id) => {
  const index = formModel.value.tableData.findIndex((item) => item.id === id)
  if (index < formModel.value.tableData.length - 1) {
    const item = formModel.value.tableData[index]
    set(formModel.value.tableData, index, formModel.value.tableData[index + 1])
    set(formModel.value.tableData, index + 1, item)
  }
}

// 删除
const handleDelete = (id) => {
  const index = formModel.value.tableData.findIndex((item) => item.id === id)
  // 保存选中状态（排除被删除的项）
  const selectedIds = saveSelectionState().filter((itemId) => itemId !== id)

  const scrollTop = saveScrollPosition()

  formModel.value.tableData.splice(index, 1)

  forceRerender()

  restoreScrollPosition(scrollTop)

  restoreSelectionState(selectedIds)
}


const generateId = () => {
  return Date.now() + Math.random().toString(36).substr(2, 9)
}

const handleAddFeeItem = (feeItem) => {
  const newItem = {
    id: generateId(),
    selected: 1,
    feeType: feeItem.feeType,
    feeTypeName: feeItem.feeTypeName,
    isAdd: true,
    customFlag: 1,
  }

  formModel.value.tableData.push(newItem)

  // 等待DOM更新后滚动到最后一行
  nextTick(() => {
    const table = multipleTable.value
    if (table && table.bodyWrapper) {
      // 滚动到底部
      table.bodyWrapper.scrollTop = table.bodyWrapper.scrollHeight
    }

    // 自动选中新添加的项目
    isProgrammaticSelection.value = true
    table?.toggleRowSelection(newItem, true)
    isProgrammaticSelection.value = false
  })
}

// 保存滚动位置
const saveScrollPosition = () => {
  const table = multipleTable.value
  if (table && table.bodyWrapper) {
    return table.bodyWrapper.scrollTop
  }
  return 0
}

// 保存当前选中状态
const saveSelectionState = () => {
  const selectedRows = multipleTable.value?.selection || []
  return selectedRows.map((row) => row.id)
}

// 恢复滚动位置
const restoreScrollPosition = (scrollTop) => {
  nextTick(() => {
    const table = multipleTable.value
    if (table && table.bodyWrapper) {
      table.bodyWrapper.scrollTop = scrollTop
    }
  })
}

// 恢复选中状态
const restoreSelectionState = (selectedIds) => {
  if (!selectedIds.length) return

  nextTick(() => {
    isProgrammaticSelection.value = true

    // 清空当前选中
    multipleTable?.value?.clearSelection()

    // 根据保存的ID重新选中
    formModel.value.tableData.forEach((row) => {
      if (selectedIds.includes(row.id)) {
        multipleTable?.value?.toggleRowSelection(row, true)
      }
    })

    isProgrammaticSelection.value = false
  })
}

const getCustomFeeListFromEnum = async () => {
  const { code, data } = await getEnum({
    type: 'withholdCustomFee',
  })
  if (code === 1) {
    customFeeList.value = data.map((item) => {
      return {
        feeTypeName: item.name,
        feeType: item.code,
        customFlag: 1,
      }
    })
  }
}


const getCustomFeeList = computed(() => {
  return customFeeList.value.filter((item) => {
    return !formModel.value.tableData.some((row) => row.feeType === item.feeType)
  })
})

const getAddItemDisabled = computed(() => {
  const addedList = formModel.value.tableData.filter((item) => item.isAdd)
  return getCustomFeeList.value.length === 0
  || addedList.length >= customFeeList.value.length
})

const getFeeTableData = () => {
  return new Promise((resolve, reject) => {
    feeForm.value.validate((valid) => {
      if (valid) {
        resolve(formModel.value.tableData)
      } else {
        reject(new Error('FeeTable validation failed'))
      }
    })
  })
}

watch(allFeeTypeList, (newVal) => {
  if (newVal.length && formModel.value.tableData.length === 0) {
    formModel.value.tableData = newVal.map((item) => ({
      id: generateId(),
      selected: 0,
      feeAmount: item.feeAmount,
      feeType: item.feeType,
      feeTypeName: item.feeTypeName,
      isAdd: false,
      customFlag: 0,
    }))
  }
}, { immediate: true })

getCustomFeeListFromEnum()

defineExpose({
  getFeeTableData,
})

</script>

<style lang="scss" scoped>
.deduction-list {
  margin-bottom: 12px;
}
.deduction-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 10px;
  .red-marker {
    color: #ff4d4f;
    margin-right: 4px;
  }
  .fee-description {
    font-size: 12px;
    color: #999;
    font-weight: 400;
    margin-left: 10px;
  }
}
.action-buttons {
  .el-button {
    padding: 0;
  }
}
.amount-input {
  width: 150px;
  margin: 0 auto;
}

.amount-input ::v-deep .el-form-item__content {
  margin-bottom: 24px;
}
</style>
